import * as Sqrl from 'squirrelly';
import {getSizedImageUrl} from '@shopify/theme-images';

import {fetchProduct} from '../util/fetch-product';
import {formatPrices} from '../util/format-prices';

const selectors = {
  template: '[pair-product-template]',
  pairProducts: '[data-pair-products]',
  upsellButton: '[data-upsell-btn]',
  upsellButtonText: '[data-upsell-btn-text]',
};

class PairWithProduct {
  constructor(handle) {
    this.handle = handle;
    this.template = document.querySelector(selectors.template).innerHTML;
    this.pairProducts = document.querySelector(selectors.pairProducts);
    this.resizeEventUpsell = () => this.calcUpsellButtonDemensions();
    this.variant = null;
    this.variantObject = null;

    this.init();
  }

  init() {
    if (this.handle.includes('_')) {
      const parts = this.handle.split('_');
      this.handle = parts[0];
      this.variant = parts[1];
    }

    this.upsellButtonDemensionsListener();

    fetchProduct(this.handle)
      .then((response) => {
        if (response === undefined) {
          document.dispatchEvent(new CustomEvent('theme:upsell:fetch-error'));

          return;
        }

        const formatted = formatPrices(response);

        let availableVariant = false;

        if (this.variant !== null) {
          formatted.variants.filter((variant) => {
            if (variant.id === Number(this.variant) && variant.available) {
              this.variantObject = variant;
              availableVariant = true;
            }

            return variant;
          });
        }

        if (formatted.available && this.variant === null) {
          this.renderPairProduct(formatted);
        } else if (availableVariant) {
          this.renderPairProduct(formatted);
        } else {
          this.pairProducts.innerHTML = '';
          document.dispatchEvent(new CustomEvent('theme:upsell:unavailable'));
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  renderPairProduct(formatted) {
    const productMarkup = this.renderProduct(formatted);

    this.pairProducts.innerHTML = productMarkup;

    this.calcUpsellButtonDemensions();
  }

  upsellButtonDemensionsListener() {
    document.addEventListener('theme:resize', this.resizeEventUpsell);
  }

  calcUpsellButtonDemensions() {
    const upsellButtonText = this.pairProducts.querySelector(selectors.upsellButtonText);
    const button = this.pairProducts.querySelector(selectors.upsellButton);

    if (upsellButtonText) {
      button.style.setProperty('--btn-text-width', `${upsellButtonText.clientWidth}px`);
    }
  }

  renderProduct(currentProduct) {
    let media = null;
    let image = '';
    let firstAvailableVariant = '';
    let hasVariants = true;
    let hasUnitPrice = false;

    if (currentProduct.media !== undefined) {
      media = currentProduct.media[0];
    }

    if (this.variantObject !== null && this.variantObject.featured_media !== undefined) {
      media = this.variantObject.featured_media;
    }

    if (currentProduct.options[0].name === 'Title' && currentProduct.options.length === 1 && currentProduct.options[0].values[0] === 'Default Title') {
      hasVariants = false;
    }

    if (this.variantObject === null) {
      for (let index = 0; index < currentProduct.variants.length; index++) {
        const variant = currentProduct.variants[index];

        if (variant.available) {
          const title = variant.title.replaceAll('/', '<span>&nbsp;</span>');
          hasUnitPrice = variant.unit_price !== undefined;
          const formatedVariant = formatPrices(variant);

          firstAvailableVariant = {
            ...formatedVariant,
            title,
            hasUnitPrice,
          };

          break;
        }
      }
    }

    if (this.variantObject !== null) {
      const title = this.variantObject.title.replaceAll('/', '<span>&nbsp;</span>');
      hasUnitPrice = this.variantObject.unit_price !== undefined;
      const formatedVariant = formatPrices(this.variantObject);

      firstAvailableVariant = {
        ...formatedVariant,
        title,
        hasUnitPrice,
      };
    }

    if (firstAvailableVariant === '') {
      return '';
    }

    const title = currentProduct.title.replace(/(<([^>]+)>)/gi, '');

    if (firstAvailableVariant.unit_price_measurement) {
      firstAvailableVariant.unitValue = firstAvailableVariant.unit_price_measurement.reference_unit;

      if (firstAvailableVariant.unit_price_measurement.reference_value !== 1) {
        firstAvailableVariant.unitCount = firstAvailableVariant.unit_price_measurement.reference_value;
      }
    }

    if (firstAvailableVariant.featured_media) {
      image = {
        thumb: getSizedImageUrl(firstAvailableVariant.featured_media.preview_image.src, '240x240'),
      };
    } else if (media) {
      image = {
        thumb: getSizedImageUrl(media.preview_image.src, '240x240'),
      };
    } else {
      image = {
        thumb: window.theme.assets.no_image,
      };
    }

    const updateValues = {
      ...currentProduct,
      title,
      image,
      firstAvailableVariant,
      hasVariants,
      addToCartText: theme.strings.upsellAddToCart,
      unitPriceLabel: theme.strings.unitPrice,
      unitPriceSeparator: theme.strings.unitPriceSeparator,
    };

    return Sqrl.render(this.template, {product: updateValues});
  }
}

export default PairWithProduct;
